// extracted by mini-css-extract-plugin
export default {"home":"ResetPassword_home__xp4B5"};